<div class="base-component">
  <h5 class="title text-hard-blue">Notas</h5>
  {{ items }}
</div>

<!-- <mat-expansion-panel class="base-component panel-header">
  <mat-expansion-panel-header class="mat-indicator">
    <a class="title font-color title-size">Notas</a>
  </mat-expansion-panel-header>
  <div class="content font-color">
    {{ items }}
  </div>
</mat-expansion-panel> -->
